<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid pt-3" style="height:100%">
    <div class="row">
      <div class="col" style="height:100%">
        <div class="timeline timeline-left">
          <div class="timeline-container" id="timeline-container-id">

            <div class="timeline-row" v-for="(val, index) in procedureHistory">
              <div class="timeline-icon">
                <div v-bind:class="val.StatusCssClass"></div>
              </div>

              <div class="card shadow-0 border-0 history_contanier skin light-bg">
                <div class="card-header p-2 header-elements-inline">
                  <div class="col-12 pr-4">
                    <p v-show="val.UserName!=null" class="text-default">{{ getStatusname(val.Status) + ' ' + $t('by') + ': ' + val.UserName}}</p>
                    <p v-show="val.ModifiedDay!=null" class="text-default">{{val.ModifiedDay +' '+ getLocalDatetime(val.ModifiedOn)}}</p>
                    <p v-show="val.Location!=null" class="text-default">
                      {{ $store.translate('location')}}: {{val.Location}}<map-button class="ml-2" v-show="val.Address != null && val.Address != ''" v-bind:adress="val.Address"></map-button>
                    </p>
                    <p v-show="val.Orgnization!=null" class="text-default">{{$t('organisation')}}: {{val.Orgnization}}</p>
                    <p v-show="val.Shift!=null" class="text-default">{{$t('shift')}}: {{val.Shift}}</p>
                  </div>

                <div class="pull-right" style="position: absolute;right: 0px;top: 5px; margin-right:5px;">
                  <div class="dropdown pull-right pr-2">
                    <a href="#" class="list-icons-item caret-0 font-weight-bold" data-toggle="dropdown">
                      <i class="icon-menu"></i>
                    </a>
                    <div class="skinnedmenu dropdown-menu dropdown-menu-right">
                      <a @click="goto(val.ProcedureScheduleId)" href="#" class="dropdown-item">{{$t('view')}} </a>
                      <a @click="deleteScheduling(val.ProcedureScheduleId)" href="#" class="dropdown-item">{{$t('delete')}} </a>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
      </div>


    </div>

  </div>
</template>

<script>

  //import discussSinglethread from '../discuss/discuss-singlethread.vue'
  import MapButton from "../maps/map-button.vue";
  import containerExpandRight from '../containers/container-expand-right.vue'
  import vuescroll from 'vuescroll';
  //var procedureHistory = [
  //  {
  //    Id:1,
  //    LongName: "Test",
  //    StatusName: "Done",
  //    UserName: "Olle",
  //    ProcedureScheduleId: 1,
  //    Datescheduled: "2020-01-01",
  //    StatusCssClass: "bg-success",
  //  },
  //  {
  //    Id: 2,
  //    LongName: "Test",
  //    StatusName: "Done",
  //    UserName: "Olle",
  //    ProcedureScheduleId: 1,
  //    Datescheduled: "2020-01-01",
  //    StatusCssClass: "bg-danger",
  //  }
  //]

  var statuses = [
    'created',
    'started',
    'done',
    'verified',
    'closed'
  ]


  export default {
    name: "procedure-historymode",
    components: {
      containerExpandRight,
      vuescroll,
      MapButton
    },
    props: {
      procedureid: {
        required: false,
        type: Number,
        default: null
      }
    },
    computed: {
      procedure: {
        get() {
          return this.$store.state.procedure;
        },
        set(value) {
          //alert("updateprocedure 13");
          this.$store.commit('saveprocedure', value)
        }
      }
    },
    data() {
      return {
        procedureHistory: [],
        statuses,
        ops: {
          vuescroll: {
            mode: 'slide',
          },
          scrollPanel: {
            scrollingX: false
          },
          rail: {
            background: '#F6F7F7',
            opacity: 0.5,
            size: '6px',
            specifyBorderRadius: false,
            gutterOfEnds: null,
            gutterOfSide: '2px',
            keepShow: false
          },
          bar: {
            onlyShowBarOnScroll: false,
            keepShow: true,
            background: '#666767',
          }
        }
      };
    },

    methods: {
      getLocalDatetime(d) {       
        const local = convertUtcToLocal(d);
        return local;
      },

      getStatusname(id) {
        if (id < this.statuses.length)
          return this.statuses[id];
        return "";
      },

      loadProcedureHistory() {
        try {
          var procId = this.procedureid;
          if (procId !== null) {
            this.$http.get('/api/Procedures/v1/GetProcedureHistoryDetail?procedureId=' + procId).then(async response => {
              this.procedureHistory = response.data;
            });
          }
        }
        catch (err) {
          //alert('some error:' + err)
        }
      },
      goto(id) {        
        this.$parent.scheduleid = id;        
        var url = store.getTodoUrl() + "?procedureid=" + this.procedureid + "&procedureScheduleId=" + id;
        window.open(url);
      },
      deleteScheduling(id) {
        var context = this;
        bootbox.confirm(this.$t('confirm_delete'), function (result) {
          if (result) {
            try {
              var url = '/api/Procedure/DeleteScheduling?procedureScheduleid=' + id;
              context.$http.get(url).then(async response => {
                context.loadProcedureHistory();
              });
            } catch (err) {
              alert(err);
            }
          }
        });
      },
      loadThread(id) {
        //alert('loading thread for id:' + id);
      },
      handleRefresh(val) {
        this.$forceUpdate();
      }
    },
    mounted() {
      //this.loadProcedureHistory();

      this.statuses[0] = this.$t('created');
      this.statuses[1] = this.$t('started');
      this.statuses[2] = this.$t('done');
      this.statuses[3] = this.$t('verified');
      this.statuses[4] = this.$t('closed');

    },
    created() {
      this.$root.$on('procedure_refresh', this.handleRefresh);
    },
  };

</script>

<style scoped>
  #timeline-container-id::after {
    z-index: 1 !important;
  }

  .timeline-row {
    z-index: 2 !important;
  }

  .history_contanier {
    box-shadow: none;
  }

    .history_contanier .header-elements-inline {
      padding-top: 1.0rem;
    }

  .timeline-icon {
    width: 24px;
    height: 24px;
  }


  @media (min-width: 768px) {
    .timeline-icon {
      margin-left: 12px !important;
      margin: 0 auto 1.25rem 0.4rem;
    }
  }

  @media (max-width: 768px) {
  }
</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-historymode.vue